import debounce from 'lodash.debounce';
import { useState, useEffect, useRef, useCallback } from 'react';
import APIEndpoints from 'src/Member/api/APIEndpoints';
import ToastMessage from 'src/Member/components/common/ToastMessage';
import { toast } from 'react-toastify';
import { arrayBufferToBase64 } from 'src/Member/utils/common';
import { axiosInstance } from 'src/api/axios';
import * as yup from 'yup';
import { useSelector } from 'react-redux';
import useMessageAndNotification from '../../common-hook/useMessageAndNotification';

const useMyMessage = ({
  messageSelectedFromPopup,
  setIsComposed,
  selectedTabLocal,
}) => {
  const SortByDummyOptions = [
    { label: 'Latest', value: 'desc' },
    { label: 'Oldest', value: 'asc' },
  ];

  console.log('setIsComposed', setIsComposed);
  const typeDropdownOptions = [
    { label: 'Authorizations', value: 'authorizations' },
    { label: 'Fresh Claims', value: 'fresh-claims' },
    { label: 'Pre-existing Claims', value: 'pre-existing-claims' },
    { label: 'Enrollment', value: 'enrollment' },
    { label: 'Others', value: 'others' },
  ];

  const AttachmentOptions = [
    //{ label: 'Select', value: '' },
    { label: 'With Attachment', value: true },
    { label: 'Without Attachment', value: false },
  ];

  const [popUpMessageData, setPopUpMessageData] = useState(
    messageSelectedFromPopup,
  );
  const [messageDetailData, setMessageDetailData] = useState(null);

  const [initialRender, setInitialRender] = useState(true);

  //for sortby
  const [sortByData, setSortByData] = useState(SortByDummyOptions[0]);
  //for type
  const [typeData, setTypeData] = useState([]);
  //for attachments
  const [attachmentData, setAttachmentData] = useState([]);
  //for search
  const [searchText, setSearchText] = useState('');
  const [searchTextDebounce, setSearchTextDebounce] = useState('');
  const [isComposing, setIsComposing] = useState(false);
  const [replyEnabled, setReplyEnabled] = useState(false);

  const [listLoading, setListLoading] = useState(false);
  const [listApiDataNotFoundError, setListApiDataNotFoundError] =
    useState(false);
  const [listApiServerError, setListApiServerError] = useState(false);

  const [selectedTab, setSelectedTab] = useState('inbox');
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedIndexForSent, setSelectedIndexForSent] = useState(0);

  //pagination specific states
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const displayPaginationMininumCount = 10;

  const pageSizeHandler = (pageSizeInfo) => {
    setPageSize(pageSizeInfo.value);
    setCurrentPage(1);
    setSelectedIndexForSent(0);
    setSelectedIndex(0);
  };

  const paginationHandler = (page) => {
    setCurrentPage(page);
    setSelectedIndexForSent(0);
    setSelectedIndex(0);
  };

  //Search filter functionality
  const debouncedCall = useCallback(
    debounce((currentVal) => setSearchTextDebounce(currentVal), 500),
    [],
  );

  const onSearch = (e) => {
    setSearchText(e?.target?.value);
    if (e?.target?.value?.length > 2 || e?.target?.value?.length === 0) {
      setCurrentPage(1);
      debouncedCall(e?.target?.value);
    }
  };

  //Reset Filter function
  const resetFilterHandler = () => {
    setCurrentPage(1);
    setPageSize(10);
    setSortByData(SortByDummyOptions[0]);
    setTypeData([]);
    setAttachmentData([]);
    setSearchText('');
    setListApiDataNotFoundError(false);
    setListApiServerError(false);
    setMessageDetailData(null);
    setPopUpMessageData(null);
  };

  const [files, setFiles] = useState([]);
  const [filesLoader, setfilesLoader] = useState(false);
  const [subject, setSubject] = useState('');
  const [sendDocumentFor, setSendDocumentFor] = useState();
  const [refreance, setRefreance] = useState('');
  const [typeOptionList, setTypeOptionList] = useState([]);
  const [docType, setDocType] = useState();
  const [comments, setComments] = useState('');
  const [typeListValues, setTypeListValues] = useState([]);

  const formRef = useRef(null);

  const getTypeList = async () => {
    try {
      const responseTypeCategory = await axiosInstance.get(
        APIEndpoints.getTypeCategoryList(),
      );
      const typeListData =
        responseTypeCategory?.data?.Response?.MessageCategoryMaster;

      const typeCategoryValues = typeListData.map((item) => {
        return {
          label: item?.Categorydesc,
          value: item?.Categorycode,
          ...item,
        };
      });
      const uniqueTypeData = [];
      for (let i = 0; i < typeCategoryValues.length; i++) {
        if (
          !uniqueTypeData.find(
            (item) => item.label === typeCategoryValues[i]?.value,
          )
        ) {
          uniqueTypeData.push(typeCategoryValues[i]);
        }
      }
      setTypeListValues(typeListData);
      setTypeOptionList(uniqueTypeData);
    } catch (err) {
      console.log('err :', err);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    if (!initialRender) {
      getSendReceiveMessageList();
      setPopUpMessageData(null);
    }
    setMessageDetailData(null);
  }, [sortByData, typeData, attachmentData, pageSize, searchTextDebounce]);

  //useEffect(() => {
  //resetFilterHandler();
  //}, [selectedTab]);

  useEffect(() => {
    if (!initialRender) {
      getSendReceiveMessageList();
      setPopUpMessageData(null);
    }
    setMessageDetailData(null);
  }, [currentPage]);

  const getSendReceiveMessageList = async (eventType = 'messages') => {
    setListLoading(true);
    let eventTypeOid = '74c790f3-6cf8-423b-a286-2bfc2430272a';
    if (eventType === 'messages') {
      eventTypeOid = '74c790f3-6cf8-423b-a286-2bfc2430272a';
    } else if (eventType === 'document') {
      eventTypeOid = '';
    } else if (eventType === 'notification') {
      eventTypeOid = '';
    }
    let filterParams = '';
    if (sortByData?.value) {
      filterParams = filterParams + `SortDirection/${sortByData?.value}`;
    }
    if (selectedTab) {
      filterParams =
        filterParams +
        `/messagesentreceived/${selectedTab === 'inbox' ? 'R' : 'S'}`;
    }
    if (searchText?.length > 2) {
      filterParams = filterParams + `/searchkey/${searchText}`;
    }
    if (typeData?.value) {
      filterParams = filterParams + `/type/${typeData?.value}`;
    }
    if (attachmentData?.label) {
      filterParams = filterParams + `/attachments/${attachmentData?.value}`;
    }
    if (currentPage) {
      filterParams = filterParams + `/pagenumber/${currentPage}`;
    }
    if (pageSize) {
      filterParams = filterParams + `/pagesize/${pageSize}`;
    }

    try {
      setListApiDataNotFoundError(false);
      setListApiServerError(false);
      const responseMessageListResp = await axiosInstance.get(
        `${APIEndpoints.getSendReceiveMessage()}${eventTypeOid}${
          filterParams && `/${filterParams}`
        }`,
      );
      const { Pagination } = responseMessageListResp?.data?.Response || {
        PageNumber: 1,
        PageSize: 10,
        TotalRecords: 0,
      };
      const responseMessageList =
        responseMessageListResp.data.Response.listOfRRMessageDTOObj;
      const listData = [];
      if (responseMessageList?.length > 0) {
        responseMessageList.map((item, index) => {
          listData.push({
            id: item?.oid || index,
            indexValue: index,
            FirstName: '',
            LastName: '',
            EventTitle: item?.eventtitle,
            EventDesc: item?.eventdesc,
            MessagecategorymasterDTOObj: {
              Categorydesc: item?.messagecategorymaster?.categorydesc,
            },
            isDmsDoc: item?.DmsDocument,
            isread: item?.isread,
            attachments: item?.attachments,
            attachmentsDetail: item?.rrmessageDocumentDetailDTO,
            ReceivedDateTime: item?.receiveddatetime,
          });
          return 0;
        });
        console.log('listData', listData);
        setFilteredData(listData);
        if (
          listData.findIndex((item) => item?.id === popUpMessageData?.Oid) >
            -1 &&
          popUpMessageData?.Oid
        ) {
          setSelectedIndex(
            listData.findIndex((item) => item?.id === popUpMessageData?.Oid),
          );
          setMessageDetailData(
            listData.filter((item) => item.id === popUpMessageData?.Oid)[0],
          );
          !popUpMessageData.isread &&
            selectedTabLocal === 'messages' &&
            markeMessageAsRead(popUpMessageData.Oid, true);
        } else {
          setSelectedIndex(0);
          setMessageDetailData(listData[0]);
          !listData[0].isread &&
            selectedTabLocal === 'messages' &&
            markeMessageAsRead(listData[0].id, true);
        }
        setTotalRecords(Pagination?.TotalRecords);
      }
    } catch (error) {
      console.log('error :', error);
      if (error?.toString()?.includes('404')) {
        setListApiDataNotFoundError(true);
        setListApiServerError(true);
      }
      setListApiServerError(true);
      setFilteredData([]);
      setTotalRecords(0);
    } finally {
      setListLoading(false);
    }
  };

  const markeMessageAsRead = (oid, isRead = true) => {
    const payload = {
      ReadFlag: [
        {
          oid: oid,
          IsRead: isRead,
        },
      ],
    };
    //eslint-disable-next-line no-unused-vars
    const responseMessageListResp = axiosInstance.post(
      APIEndpoints.markMessageIsRead(),
      payload,
    );
    responseMessageListResp
      .then((res) => {
        if (res?.status === 201) {
          updateNotificationCount();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const schema = yup.object({
    subject: yup.string().required('Enter Subject '),
    type: yup.object().required('Please select a type'),
    refreance: yup.string().when('type', (type, schema) => {
      if (type[0]?.MappedEntity === 'CLAIM') {
        return schema.required('Enter Refrance');
      } else {
        return schema;
      }
    }),
    comments: yup.string().required('Enter message '),
  });

  const replyMessageSchema = yup.object({
    subject: yup.string().required('Enter Subject '),
    type: yup.object().required('Please select a type'),
    file: yup.array(),
    comments: yup.string(),
  });

  //#TODO below code use in future while implementing reply and compose messages
  const userData = useSelector((state) => state?.user?.userData);

  const commonPayload = {
    UserType: userData?.UserType,
    Caller: userData?.MemberDetails?.MemberName,
    Customer: userData?.MemberDetails?.MemberName,
    Callertype: userData?.UserType === 'Employee' ? '4' : '3',
    CustomerType: userData?.UserType,
    UserOid: userData?.Oid, //userData?.UserOid
    CustomerOid: userData?.MemberDetails?.MemberOID,
    EventTypeOid: '74c790f3-6cf8-423b-a286-2bfc2430272a',
    MessageSentTo: 'Javelina',
    MessageTriggerFrom: 'P',
  };

  const submitComposeMessage = (values) => {
    console.log('values :', values);
    let msg = '';

    if (values?.file?.length > 0 && values?.type?.MappedEntity === 'CLAIM') {
      if (!values?.refreance) {
        msg = 'Please enter reference number';
      }
      //else if (getTotalFileSizes() > 20) {
      //msg =
      //'Total file size exceeded. Maximum limit is 20 MB. Please select smaller files or fewer files.';
      //}
    }
  };
  const submitReplyMessage = (values) => {
    //# TODO : Call the Reply message API with following data, we may need to call first upload document api
    console.log('values :', values);
  };
  const getSanitizedContent = (content) => {
    let modifiedContent = '';
    if (
      content?.toString()?.startsWith('"') &&
      content?.toString()?.endsWith('"')
    ) {
      modifiedContent = content?.substring(1, content?.length - 1);
    } else {
      modifiedContent = content;
    }
    const splitedContent = modifiedContent
      ?.toString()
      ?.replace(/\\n/g, '')
      ?.replace(/\n/g, '<br />');
    return splitedContent;
  };

  const downloadFile = async (reportName, byte, contentType) => {
    const actualData = arrayBufferToBase64(byte);
    const link = document.createElement('a');
    link.setAttribute('href', `data:${contentType};base64,` + actualData);
    link.setAttribute('download', reportName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadDmsDocumentHandler = async (item) => {
    try {
      const documentData = await axiosInstance.get(
        `${APIEndpoints.getDocument() + item?.Oid}`,
        { responseType: 'arraybuffer' },
      );
      const contentType = documentData?.headers['content-type'];
      downloadFile(item?.OrigFileName, documentData?.data, contentType);
    } catch (error) {
      console.log('error :', error);
      if (error?.toString()?.includes('404')) {
        console.log('404 error');
        toast.error(
          <ToastMessage
            type="error"
            title="File not found!"
            subTitle="Could not download the file. Contact your Administrator for more information."
          />,
        );
      } else {
        toast.error(
          <ToastMessage
            type="error"
            title="Something went wrong!"
            subTitle="Could not download the file. Try again later."
          />,
        );
      }
    }
  };

  const downloadNonDmsDocumentHandler = async (item) => {
    try {
      const docLocation = btoa(item?.Location);
      const responseDetails = await axiosInstance.get(
        `${APIEndpoints.getDocumentsDownload()}doclocation/${docLocation}/id/${
          item?.DocControlNo
        }`,
        { responseType: 'arraybuffer' },
      );
      const contentType = responseDetails.headers['content-type'];
      downloadFile(item?.OrigFileName, responseDetails?.data, contentType);
    } catch (error) {
      if (error?.toString()?.includes('404')) {
        console.log('404 error');
        toast.error(
          <ToastMessage
            type="error"
            title="File not found!"
            subTitle="Could not download the file. Contact your Administrator for more information."
          />,
        );
      } else {
        toast.error(
          <ToastMessage
            type="error"
            title="Something went wrong!"
            subTitle="Could not download the file. Try again later."
          />,
        );
      }
    }
  };

  const downloadFileHandler = async (item) => {
    if (item?.isDmsDoc) {
      downloadDmsDocumentHandler(item);
    } else {
      downloadNonDmsDocumentHandler(item);
    }
  };
  const downloadAllFileHandler = async (items) => {
    items?.attachmentsDetail?.map(async (file) => {
      const uploadResponse = await (items?.isDmsDoc
        ? downloadDmsDocumentHandler(file)
        : downloadNonDmsDocumentHandler(file));
      return uploadResponse;
    });
  };

  useEffect(() => {
    getTypeList();
    setInitialRender(false);
  }, []);

  const { updateNotificationCount } = useMessageAndNotification({
    filteredData,
    setFilteredData,
    messageDetailData,
    setMessageDetailData,
  });
  return {
    sortByData,
    searchText,
    typeData,
    SortByDummyOptions,
    typeDropdownOptions,
    setSortByData,
    setTypeData,
    AttachmentOptions,
    attachmentData,
    setAttachmentData,
    onSearch,
    resetFilterHandler,
    filteredData,
    pageSize,
    currentPage,
    totalRecords,
    displayPaginationMininumCount,
    pageSizeHandler,
    paginationHandler,
    setCurrentPage,
    setTotalRecords,
    setPageSize,
    isComposing,
    setIsComposing,
    replyEnabled,
    setReplyEnabled,
    schema,
    replyMessageSchema,
    submitComposeMessage,
    submitReplyMessage,
    files,
    setFiles,
    filesLoader,
    subject,
    sendDocumentFor,
    refreance,
    docType,
    comments,
    typeOptionList,
    formRef,
    setComments,
    setDocType,
    setfilesLoader,
    setSubject,
    setSendDocumentFor,
    setRefreance,
    typeListValues,
    getSendReceiveMessageList,
    listLoading,
    listApiDataNotFoundError,
    listApiServerError,
    selectedTab,
    setSelectedTab,
    setSelectedIndex,
    selectedIndex,
    setSelectedIndexForSent,
    selectedIndexForSent,
    setMessageDetailData,
    messageDetailData,
    typeOptionList,
    getSanitizedContent,
    downloadFileHandler,
    downloadAllFileHandler,
    markeMessageAsRead,
  };
};

export default useMyMessage;
